import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

//@ts-ignore
import ogpImage from "./../images/ogp.png"

import { genJsonLdOrganization } from "./../utils/seo"

type Props = {
  children?: React.ReactNode | undefined
  title: string
  description: string
  url: string
  imageURL?: string
  pageType?: "article" | "website"
  canonicalURL?: string
}

const SEO: React.FC<Props> = ({
  children,
  title = "",
  description = "",
  url = "",
  imageURL = "",
  pageType = "article",
  canonicalURL = "",
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteName
            siteUrl
          }
        }
      }
    `
  )

  const metaTitle = title || site.siteMetadata.title
  const metaDescription = description || site.siteMetadata.description
  const metaURL = url
    ? url.startsWith("http")
      ? url
      : `${site.siteMetadata.siteUrl}${url}`
    : site.siteMetadata.siteUrl
  const metaImageURL = imageURL
    ? imageURL.startsWith("http")
      ? imageURL
      : `${site.siteMetadata.siteUrl}${imageURL}`
    : `${site.siteMetadata.siteUrl}${ogpImage}`
  const metaCanonicalURL = canonicalURL
    ? canonicalURL.startsWith("http")
      ? canonicalURL
      : `${site.siteMetadata.siteUrl}${canonicalURL}`
    : metaURL

  const jsonLdOrganization = genJsonLdOrganization({
    siteName: site.siteMetadata.siteName,
    siteURL: site.siteMetadata.siteUrl,
    siteSameURLs: [
      "https://www.instagram.com/paircare/",
      "https://twitter.com/paircare_jp",
      "https://www.facebook.com/paircare.jp/",
    ],
  })
  return (
    <>
      <title>{metaTitle}</title>
      <link href="/favicon.ico" rel="icon" />
      <link href="https://connect.facebook.net" rel="preconnect" />
      <link href="https://d.line-scdn.net" rel="preconnect" />
      <link href="https://www.facebook.com" rel="preconnect" />
      <link href="https://tr.line.me" rel="preconnect" />
      <link href={metaCanonicalURL} rel="canonical" />
      <meta name="description" content={metaDescription} />
      <meta name="robots" content="max-snippet:-1, max-image-preview:large" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaURL} />
      <meta property="og:type" content={pageType} />
      <meta property="og:image" content={metaImageURL} />
      <meta property="og:site_name" content={site.siteMetadata.siteName} />
      <meta property="fb:app_id" content="2363697587283891" />
      <meta name="twitter:site" content="@paircare_jp" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <script type="application/ld+json">
        {JSON.stringify(jsonLdOrganization)}
      </script>
      {children}
    </>
  )
}

export default SEO
